"use strict";
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.ContentType = exports.InboxSearchCreateParamsEnum = exports.InboxSearchCreateParamsTypeEnum = exports.ServiceDataRequestLocationTypeEnum = exports.AppointmentSaveRequestLocationTypeEnum = exports.AppointmentSaveRequestWaitlistEnum = exports.AppointmentSaveRequestReminderEnum = exports.InviteAvailabilitySaveRequestTypeEnum = exports.InviteSaveRequestTypeEnum = exports.InviteSaveRequestInviteTypeEnum = exports.InviteSaveRequestLocationTypeEnum = exports.InviteSaveRequestVideoConferenceDetailsTypeEnum = exports.InviteSaveRequestLimitTypeEnum = exports.InviteSaveRequestAvailabilityOptionEnum = exports.InviteSaveRequestMatchOnObjectEnum = exports.CalendarRequestDynamicTravelTimeStrategyEnum = void 0;
/**
 * Based on currrent template field DynamicTravelTimeStrategy__c
 * @example "DISABLED"
 */
var CalendarRequestDynamicTravelTimeStrategyEnum;
(function (CalendarRequestDynamicTravelTimeStrategyEnum) {
    CalendarRequestDynamicTravelTimeStrategyEnum["DISABLED"] = "DISABLED";
    CalendarRequestDynamicTravelTimeStrategyEnum["LICENSED_USERS"] = "LICENSED_USERS";
    CalendarRequestDynamicTravelTimeStrategyEnum["ALL_USERS"] = "ALL_USERS";
})(CalendarRequestDynamicTravelTimeStrategyEnum = exports.CalendarRequestDynamicTravelTimeStrategyEnum || (exports.CalendarRequestDynamicTravelTimeStrategyEnum = {}));
/**
 * the name of object to match availability against.
 * @example "BUSINESS_CONTACTS"
 */
var InviteSaveRequestMatchOnObjectEnum;
(function (InviteSaveRequestMatchOnObjectEnum) {
    InviteSaveRequestMatchOnObjectEnum["LEADS"] = "LEADS";
    InviteSaveRequestMatchOnObjectEnum["BUSINESS_CONTACTS"] = "BUSINESS_CONTACTS";
    InviteSaveRequestMatchOnObjectEnum["PERSON_ACCOUNTS"] = "PERSON_ACCOUNTS";
})(InviteSaveRequestMatchOnObjectEnum = exports.InviteSaveRequestMatchOnObjectEnum || (exports.InviteSaveRequestMatchOnObjectEnum = {}));
/**
 * Custom availability selection option.
 * @example "OPEN"
 */
var InviteSaveRequestAvailabilityOptionEnum;
(function (InviteSaveRequestAvailabilityOptionEnum) {
    InviteSaveRequestAvailabilityOptionEnum["OPEN"] = "OPEN";
    InviteSaveRequestAvailabilityOptionEnum["CUSTOM"] = "CUSTOM";
    InviteSaveRequestAvailabilityOptionEnum["ROLLING_WINDOW"] = "ROLLING_WINDOW";
    InviteSaveRequestAvailabilityOptionEnum["DATE_RANGE"] = "DATE_RANGE";
    InviteSaveRequestAvailabilityOptionEnum["TRAVEL_TIME_GAP"] = "TRAVEL_TIME_GAP";
})(InviteSaveRequestAvailabilityOptionEnum = exports.InviteSaveRequestAvailabilityOptionEnum || (exports.InviteSaveRequestAvailabilityOptionEnum = {}));
/**
 * Limit type for appointments
 * @example "LINK"
 */
var InviteSaveRequestLimitTypeEnum;
(function (InviteSaveRequestLimitTypeEnum) {
    InviteSaveRequestLimitTypeEnum["LINK"] = "LINK";
    InviteSaveRequestLimitTypeEnum["PARTICIPANT"] = "PARTICIPANT";
})(InviteSaveRequestLimitTypeEnum = exports.InviteSaveRequestLimitTypeEnum || (exports.InviteSaveRequestLimitTypeEnum = {}));
/**
 * whom video conference detauls need to use
 * @example "Host"
 */
var InviteSaveRequestVideoConferenceDetailsTypeEnum;
(function (InviteSaveRequestVideoConferenceDetailsTypeEnum) {
    InviteSaveRequestVideoConferenceDetailsTypeEnum["Host"] = "Host";
    InviteSaveRequestVideoConferenceDetailsTypeEnum["PrimaryParticipan"] = "Primary Participan";
})(InviteSaveRequestVideoConferenceDetailsTypeEnum = exports.InviteSaveRequestVideoConferenceDetailsTypeEnum || (exports.InviteSaveRequestVideoConferenceDetailsTypeEnum = {}));
/**
 * Type that choosen on UI
 * @example "VID_CONFERENCE"
 */
var InviteSaveRequestLocationTypeEnum;
(function (InviteSaveRequestLocationTypeEnum) {
    InviteSaveRequestLocationTypeEnum["VID_CONFERENCE"] = "VID_CONFERENCE";
    InviteSaveRequestLocationTypeEnum["PHONE"] = "PHONE";
    InviteSaveRequestLocationTypeEnum["IN_PERSON"] = "IN_PERSON";
})(InviteSaveRequestLocationTypeEnum = exports.InviteSaveRequestLocationTypeEnum || (exports.InviteSaveRequestLocationTypeEnum = {}));
/**
 * Type of invite.
 * @example "EMAIL_INVITE"
 */
var InviteSaveRequestInviteTypeEnum;
(function (InviteSaveRequestInviteTypeEnum) {
    InviteSaveRequestInviteTypeEnum["EMAIL_INVITE"] = "EMAIL_INVITE";
    InviteSaveRequestInviteTypeEnum["INVITE_LINK"] = "INVITE_LINK";
})(InviteSaveRequestInviteTypeEnum = exports.InviteSaveRequestInviteTypeEnum || (exports.InviteSaveRequestInviteTypeEnum = {}));
/**
 * Type of availability scheduling
 * @default "dateSpecific"
 * @example "dateSpecific"
 */
var InviteSaveRequestTypeEnum;
(function (InviteSaveRequestTypeEnum) {
    InviteSaveRequestTypeEnum["DateSpecific"] = "dateSpecific";
    InviteSaveRequestTypeEnum["Recurring"] = "recurring";
})(InviteSaveRequestTypeEnum = exports.InviteSaveRequestTypeEnum || (exports.InviteSaveRequestTypeEnum = {}));
/**
 * The type of availability to save. Supported values: `recurring`, `dateSpecific`. The default value is `dateSpecific`
 * @default "dateSpecific"
 * @example "dateSpecific"
 */
var InviteAvailabilitySaveRequestTypeEnum;
(function (InviteAvailabilitySaveRequestTypeEnum) {
    InviteAvailabilitySaveRequestTypeEnum["Recurring"] = "recurring";
    InviteAvailabilitySaveRequestTypeEnum["DateSpecific"] = "dateSpecific";
})(InviteAvailabilitySaveRequestTypeEnum = exports.InviteAvailabilitySaveRequestTypeEnum || (exports.InviteAvailabilitySaveRequestTypeEnum = {}));
/**
 * Reminder type
 * @example "DO_NOT_SEND"
 */
var AppointmentSaveRequestReminderEnum;
(function (AppointmentSaveRequestReminderEnum) {
    AppointmentSaveRequestReminderEnum["DO_NOT_SEND"] = "DO_NOT_SEND";
    AppointmentSaveRequestReminderEnum["EMAIL_ONLY"] = "EMAIL_ONLY";
    AppointmentSaveRequestReminderEnum["SMS_ONLY"] = "SMS_ONLY";
    AppointmentSaveRequestReminderEnum["EMAIL_SMS"] = "EMAIL_SMS";
})(AppointmentSaveRequestReminderEnum = exports.AppointmentSaveRequestReminderEnum || (exports.AppointmentSaveRequestReminderEnum = {}));
/**
 * Waitlist type
 * @example "DO_NOT_SEND"
 */
var AppointmentSaveRequestWaitlistEnum;
(function (AppointmentSaveRequestWaitlistEnum) {
    AppointmentSaveRequestWaitlistEnum["DO_NOT_SEND"] = "DO_NOT_SEND";
    AppointmentSaveRequestWaitlistEnum["EMAIL_ONLY"] = "EMAIL_ONLY";
    AppointmentSaveRequestWaitlistEnum["SMS_ONLY"] = "SMS_ONLY";
    AppointmentSaveRequestWaitlistEnum["EMAIL_SMS"] = "EMAIL_SMS";
})(AppointmentSaveRequestWaitlistEnum = exports.AppointmentSaveRequestWaitlistEnum || (exports.AppointmentSaveRequestWaitlistEnum = {}));
/**
 * Type that choosen on UI
 * @example "VID_CONFERENCE"
 */
var AppointmentSaveRequestLocationTypeEnum;
(function (AppointmentSaveRequestLocationTypeEnum) {
    AppointmentSaveRequestLocationTypeEnum["VID_CONFERENCE"] = "VID_CONFERENCE";
    AppointmentSaveRequestLocationTypeEnum["PHONE"] = "PHONE";
    AppointmentSaveRequestLocationTypeEnum["IN_PERSON"] = "IN_PERSON";
})(AppointmentSaveRequestLocationTypeEnum = exports.AppointmentSaveRequestLocationTypeEnum || (exports.AppointmentSaveRequestLocationTypeEnum = {}));
/**
 * Location type chosen on UI; used to filter allowed services via LocationOptions__c
 * @example "VID_CONFERENCE"
 */
var ServiceDataRequestLocationTypeEnum;
(function (ServiceDataRequestLocationTypeEnum) {
    ServiceDataRequestLocationTypeEnum["VID_CONFERENCE"] = "VID_CONFERENCE";
    ServiceDataRequestLocationTypeEnum["PHONE"] = "PHONE";
    ServiceDataRequestLocationTypeEnum["IN_PERSON"] = "IN_PERSON";
})(ServiceDataRequestLocationTypeEnum = exports.ServiceDataRequestLocationTypeEnum || (exports.ServiceDataRequestLocationTypeEnum = {}));
/** Type of inbox items to search */
var InboxSearchCreateParamsTypeEnum;
(function (InboxSearchCreateParamsTypeEnum) {
    InboxSearchCreateParamsTypeEnum["Services"] = "services";
    InboxSearchCreateParamsTypeEnum["Hosts"] = "hosts";
    InboxSearchCreateParamsTypeEnum["Attendees"] = "attendees";
    InboxSearchCreateParamsTypeEnum["Locations"] = "locations";
    InboxSearchCreateParamsTypeEnum["Rooms"] = "rooms";
    InboxSearchCreateParamsTypeEnum["Resources"] = "resources";
})(InboxSearchCreateParamsTypeEnum = exports.InboxSearchCreateParamsTypeEnum || (exports.InboxSearchCreateParamsTypeEnum = {}));
var InboxSearchCreateParamsEnum;
(function (InboxSearchCreateParamsEnum) {
    InboxSearchCreateParamsEnum["Services"] = "services";
    InboxSearchCreateParamsEnum["Hosts"] = "hosts";
    InboxSearchCreateParamsEnum["Attendees"] = "attendees";
    InboxSearchCreateParamsEnum["Locations"] = "locations";
    InboxSearchCreateParamsEnum["Rooms"] = "rooms";
    InboxSearchCreateParamsEnum["Resources"] = "resources";
})(InboxSearchCreateParamsEnum = exports.InboxSearchCreateParamsEnum || (exports.InboxSearchCreateParamsEnum = {}));
const axios_1 = __importDefault(require("axios"));
var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["JsonApi"] = "application/vnd.api+json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
    ContentType["Text"] = "text/plain";
})(ContentType = exports.ContentType || (exports.ContentType = {}));
class HttpClient {
    constructor({ securityWorker, secure, format, ...axiosConfig } = {}) {
        Object.defineProperty(this, "instance", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "securityData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "securityWorker", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "secure", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "format", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "setSecurityData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (data) => {
                this.securityData = data;
            }
        });
        Object.defineProperty(this, "request", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async ({ secure, path, type, query, format, body, ...params }) => {
                const secureParams = ((typeof secure === "boolean" ? secure : this.secure) &&
                    this.securityWorker &&
                    (await this.securityWorker(this.securityData))) ||
                    {};
                const requestParams = this.mergeRequestParams(params, secureParams);
                const responseFormat = format || this.format || undefined;
                if (type === ContentType.FormData &&
                    body &&
                    body !== null &&
                    typeof body === "object") {
                    body = this.createFormData(body);
                }
                if (type === ContentType.Text &&
                    body &&
                    body !== null &&
                    typeof body !== "string") {
                    body = JSON.stringify(body);
                }
                return this.instance.request({
                    ...requestParams,
                    headers: {
                        ...(requestParams.headers || {}),
                        ...(type ? { "Content-Type": type } : {}),
                    },
                    params: query,
                    responseType: responseFormat,
                    data: body,
                    url: path,
                });
            }
        });
        this.instance = axios_1.default.create({
            ...axiosConfig,
            baseURL: axiosConfig.baseURL ||
                "https://virtserver.swaggerhub.com/SUMO-Scheduler/Inbox/1.0.0",
        });
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        const method = params1.method || (params2 && params2.method);
        return {
            ...this.instance.defaults,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...((method &&
                    this.instance.defaults.headers[method.toLowerCase()]) ||
                    {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        };
    }
    stringifyFormItem(formItem) {
        if (typeof formItem === "object" && formItem !== null) {
            return JSON.stringify(formItem);
        }
        else {
            return `${formItem}`;
        }
    }
    createFormData(input) {
        if (input instanceof FormData) {
            return input;
        }
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            const propertyContent = property instanceof Array ? property : [property];
            for (const formItem of propertyContent) {
                const isFileType = formItem instanceof Blob || formItem instanceof File;
                formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
            }
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title INBOX API
 * @version 1.0.0
 * @license Proprietary (http://www.omnito.ai/LICENSE.html)
 * @baseUrl https://virtserver.swaggerhub.com/SUMO-Scheduler/Inbox/1.0.0
 *
 * The API for SUMO Meeting Booker chrom exstention.
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "v1", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                /**
                 * No description
                 *
                 * @name InboxInitList
                 * @summary Get inittial data
                 * @request GET:/v1/inbox/init
                 */
                inboxInitList: (query, params = {}) => this.request({
                    path: `/v1/inbox/init`,
                    method: "GET",
                    query: query,
                    format: "json",
                    ...params,
                }),
                /**
                 * No description
                 *
                 * @name InboxInviteUrlList
                 * @summary Generate invite manager community URL by template ID
                 * @request GET:/v1/inbox/invite-url
                 */
                inboxInviteUrlList: (query, params = {}) => this.request({
                    path: `/v1/inbox/invite-url`,
                    method: "GET",
                    query: query,
                    format: "json",
                    ...params,
                }),
                /**
                 * No description
                 *
                 * @name InboxSearchCreate
                 * @summary Search data by scope
                 * @request POST:/v1/inbox/search/{type}
                 */
                inboxSearchCreate: (type, data, params = {}) => this.request({
                    path: `/v1/inbox/search/${type}`,
                    method: "POST",
                    body: data,
                    type: ContentType.Json,
                    format: "json",
                    ...params,
                }),
                /**
                 * @description Get a availability 5-minutes slots for a Users / if single user then also his activities
                 *
                 * @name InboxCalendarCreate
                 * @summary Get calendar data
                 * @request POST:/v1/inbox/calendar
                 */
                inboxCalendarCreate: (data, params = {}) => this.request({
                    path: `/v1/inbox/calendar`,
                    method: "POST",
                    body: data,
                    type: ContentType.Json,
                    format: "json",
                    ...params,
                }),
                /**
                 * @description Process to save invite link
                 *
                 * @name InboxSaveLinkCreate
                 * @summary Save invite link
                 * @request POST:/v1/inbox/save/link
                 */
                inboxSaveLinkCreate: (data, params = {}) => this.request({
                    path: `/v1/inbox/save/link`,
                    method: "POST",
                    body: data,
                    type: ContentType.Json,
                    format: "json",
                    ...params,
                }),
                /**
                 * @description Updates custom availability settings for an existing invite link. This endpoint processes availability save requests and updates both the external system and Salesforce database. The request must include: - `inviteId`: The ID of the existing invite record - `customAvailability`: Array of availability days with time ranges - `timezoneId`: Timezone for the availability settings - `type`: Type of availability (dateSpecific or recurring)
                 *
                 * @name InboxSaveCustomAvailabilityCreate
                 * @summary Save Custom Availability for invite record
                 * @request POST:/v1/inbox/save/custom-availability
                 */
                inboxSaveCustomAvailabilityCreate: (data, params = {}) => this.request({
                    path: `/v1/inbox/save/custom-availability`,
                    method: "POST",
                    body: data,
                    type: ContentType.Json,
                    format: "json",
                    ...params,
                }),
                /**
                 * @description Process to save appointment
                 *
                 * @name InboxSaveAppointmentCreate
                 * @summary Save appointment
                 * @request POST:/v1/inbox/save/appointment
                 */
                inboxSaveAppointmentCreate: (data, params = {}) => this.request({
                    path: `/v1/inbox/save/appointment`,
                    method: "POST",
                    body: data,
                    type: ContentType.Json,
                    format: "json",
                    ...params,
                }),
                /**
                 * @description Returns participant information for the provided emails based on the template ID
                 *
                 * @name InboxSearchParticipantsCreate
                 * @summary Search participants by template ID and email list
                 * @request POST:/v1/inbox/search-participants
                 */
                inboxSearchParticipantsCreate: (data, params = {}) => this.request({
                    path: `/v1/inbox/search-participants`,
                    method: "POST",
                    body: data,
                    type: ContentType.Json,
                    format: "json",
                    ...params,
                }),
                /**
                 * @description Accepts multiple service IDs and returns calculated data for them (duration, buffers, name, color, etc.). Filter them if not available by location  type or Host
                 *
                 * @name InboxServiceDataCreate
                 * @summary Get service data
                 * @request POST:/v1/inbox/service-data
                 */
                inboxServiceDataCreate: (data, params = {}) => this.request({
                    path: `/v1/inbox/service-data`,
                    method: "POST",
                    body: data,
                    type: ContentType.Json,
                    format: "json",
                    ...params,
                }),
            }
        });
    }
}
exports.Api = Api;
